/**
 * Handle refresh token status.
 */
class RefreshToken {
  static promise = null;

  static isRunning () {
    return RefreshToken.promise !== null;
  }

  static finish () {
    RefreshToken.promise = null;
  }

  static setPromise (_promise) {
    RefreshToken.promise = _promise;
  }

  static getPromise () {
    if (RefreshToken.promise === null) {
      return Promise.resolve();
    }
    return RefreshToken.promise;
  }
}

export default RefreshToken;



// WEBPACK FOOTER //
// ./src/api/auth/refreshToken.js